import React, { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../styles/Pricing.css";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

export default function Pricing() {
    useEffect(() => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: "#pricing",
                start: "top 80%",
                toggleActions: "play none none reverse"
            }
        });

        tl.fromTo(
            "#pricing .section-title",
            { y: 30, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.6, ease: "power2.out" }
        );

        tl.fromTo(
            ".pricing-intro",
            { y: 20, opacity: 0 },
            { y: 0, opacity: 1, duration: 0.6, ease: "power2.out" },
            "-=0.4"
        );

        tl.fromTo(
            ".pricing-card",
            { y: 50, opacity: 0 },
            { y: 0, opacity: 1, stagger: 0.15, duration: 0.8, ease: "power3.out" },
            "-=0.3"
        );

        return () => {
            ScrollTrigger.getAll().forEach(trigger => trigger.kill());
        };
    }, []);

    return (
        <section id="pricing">
            <div className="section-header">
                <span className="section-title">Pricing</span>
            </div>
            <div className="pricing-intro">
                <p>Tailored pricing. Strategic design.</p>
            </div>

            <div className="pricing-container">
                {/* Proof of Concept Card */}
                <div className="pricing-card">
                    <div className="pricing-header">
                        <h4 className="pricing-subtitle">[ Free ]</h4>
                        <h3 className="pricing-title">Proof of Concept</h3>
                    </div>
                    <p className="pricing-desc">
                        Perfect for seeing what your SAP or ERP data can show before committing.
                    </p>
                    <ul className="pricing-features">
                        <li>
                            <span className="bullet">✦</span> 1-page dashboard, free of cost
                        </li>
                        <li>
                            <span className="bullet">✦</span> Built from your CSV export
                        </li>
                        <li>
                            <span className="bullet">✦</span> Delivered as a .pbix file
                        </li>
                    </ul>
                    <a href="#contact" className="pricing-btn border-btn">Get in touch</a>
                </div>

                {/* Basic Card */}
                <div className="pricing-card featured">
                    <div className="pricing-header">
                        <h4 className="pricing-subtitle">[ Starts at $999/m ]</h4>
                        <h3 className="pricing-title">Basic</h3>
                    </div>
                    <p className="pricing-desc">
                        Ideal for teams that need consistent data support, a complete Power BI setup on their SAP data and continuous monitoring.
                    </p>
                    <ul className="pricing-features">
                        <li>
                            <span className="bullet">✦</span> Power BI Service setup & management
                        </li>
                        <li>
                            <span className="bullet">✦</span> Data gateway set up and monitored on your VPC
                        </li>
                        <li>
                            <span className="bullet">✦</span> End-to-end dashboards on your SAP / ERP data
                        </li>
                        <li>
                            <span className="bullet">✦</span> Weekly scrum meetings
                        </li>
                    </ul>
                    <a href="#contact" className="pricing-btn fill-btn">Get in touch</a>
                </div>

                {/* Enterprise Card */}
                <div className="pricing-card dark">
                    <div className="pricing-header">
                        <h4 className="pricing-subtitle">[ Starts at $2,999/m ]</h4>
                        <h3 className="pricing-title">Enterprise</h3>
                    </div>
                    <p className="pricing-desc">
                        Ideal for businesses scaling analytics across teams and regions without any hassle. Perfect for fast-growing companies.
                    </p>
                    <ul className="pricing-features">
                        <li>
                            <span className="bullet">✦</span> Everything in Basic
                        </li>
                        <li>
                            <span className="bullet">✦</span> End-to-end Python development, including ETL
                        </li>
                        <li>
                            <span className="bullet">✦</span> Cloud services and automated email reporting
                        </li>
                        <li>
                            <span className="bullet">✦</span> Data alerts and report subscriptions
                        </li>
                        <li>
                            <span className="bullet">✦</span> AI agents for report validation and documentation
                        </li>
                        <li>
                            <span className="bullet">✦</span> Streamlit dashboards / Power BI Embedded with RLS
                        </li>
                    </ul>
                    <a href="#contact" className="pricing-btn light-btn">Get in touch</a>
                </div>
            </div>
        </section>
    );
}
